export const youtubeTitleOptionsData = [
    {
        content: "Défaut",
        value: "default",
    },
    {
        content: "Personnalisé",
        value: "custom",
    },
];
